import type { RootState } from "@src/store/rootState";
import { selectedVariations } from "@src/store/slices/variations";

export const getInitialVariationId = (state: RootState) => {
  const variations = selectedVariations(state);
  for (const variation of variations) {
    if (!variation.isControl) {
      return variation.id;
    }
  }
  return variations?.[0].id;
};
